export enum NOTESNotaTipo {
    PUENTE = 1,
    A_MEDIDA = 2
}